export abstract class TimeParser<T> {
  abstract parse(value: string, utcOffset?: string | null): T | null;
}
